import { danger } from 'redux-store/reducers/common-reducer';
import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { API, post } from 'utils/api';
import { logError } from 'utils/log';

const { EMAIL_UNSUBSCRIPTION } = API.END_POINTS.API;

export function emailUnsubscribe(params) {
  const url = EMAIL_UNSUBSCRIPTION;
  return async (dispatch) => {
    dispatch(showLoading(url));
    try {
      await post(url, { data: params }, { suppressAuth: true });
      dispatch(hideLoading(url));
    } catch (error) {
      const { detail } = error.response.data;

      dispatch(danger(detail));
      dispatch(hideLoading(url));

      logError(error);
      throw error;
    }
  };
}
